import type { IdName } from '$lib/models/types';
import { fetchWithAuth } from '$lib/utils/http/httpUtil';
import { showToast } from '$lib/helpers/toastrHelper';
import { persisted } from 'svelte-persisted-store';
import { get } from 'svelte/store';

export function createAliiExportTypeStore() {
  const baseUrl: string = '/api/alii-export-type';

  const initial: IdName[] = [];
  const store = persisted('aliiExportTypeStore', initial, {
    storage: 'session',
  });

  return {
    get: async (): Promise<IdName[]> => {
      const sessionData = get(store);
      if (sessionData.length > 0) return sessionData;

      const response = await fetchWithAuth(baseUrl, {
        method: 'GET',
      });

      if (!response.ok) {
        const errorMessage = `Failed to fetch export types (HTTP ${response.status})`;
        showToast({
          title: 'Error',
          message: errorMessage,
          type: 'error'
        });
        return [];
      }

      try {
        const data = await response.json();
        store.set(data);
        return data;
      } catch (error) {
        showToast({
          title: 'Error',
          message: 'Failed to load export types',
          type: 'error'
        });
        return [];
      }
    },
  };
}

export const aliiExportTypeStore = createAliiExportTypeStore();
